<template>
<div class="sezione"  style="padding:0 8px;" v-if="ready">


<div class="yo-fixed-top" style="top:132px;z-index:999;">
<div class="row el-container" style="background:#fff;padding:16px 20px;">
   <div class="col s12">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="">
         <el-breadcrumb-item>Caterpillar Plot Shrunken</el-breadcrumb-item>
         <el-breadcrumb-item>Mortalità</el-breadcrumb-item>
      </el-breadcrumb>
   </div>
</div>
</div>

<div style="margin:72px 0 52px 0;">


   <div class="yo-text-xl  yo-color-primary yo-align-center" style="margin-bottom:12px;">Tasso di mortalità aggiustato (shrunken) alla dimissione nella classe di EG {{gaweakDown}}-{{gaweakUp}} per centro.<br />INNSIN 2019*</div>


   <div :style="'height:'+(gHeight+gHeightMore*2)+'px'" style="background:#ddd;width:100%;position: relative;" >

      <div v-if="(ordinata(100)>0 && ordinata(100)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(100))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(95)>0 && ordinata(95)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(95))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(90)>0 && ordinata(90)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(90))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(85)>0 && ordinata(85)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(85))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(80)>0 && ordinata(80)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(80))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(75)>0 && ordinata(75)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(75))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(70)>0 && ordinata(70)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(70))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(65)>0 && ordinata(65)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(65))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(60)>0 && ordinata(60)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(60))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(55)>0 && ordinata(55)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(55))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(50)>0 && ordinata(50)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(50))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(45)>0 && ordinata(45)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(45))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(40)>0 && ordinata(40)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(40))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(35)>0 && ordinata(35)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(35))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(30)>0 && ordinata(30)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(30))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(25)>0 && ordinata(25)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(25))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(20)>0 && ordinata(20)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(20))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(15)>0 && ordinata(15)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(15))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(10)>0 && ordinata(10)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(10))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />
      <div v-if="(ordinata(5)>0 && ordinata(5)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(5))+'px'" style="border-bottom:1px solid white;position:absolute;width:20px;left:20px;" />
      <div v-if="(ordinata(0)<gHeight+gHeightMore)" :style="'top:'+(gHeight+gHeightMore-ordinata(0))+'px'" style="border-bottom:1px solid white;position:absolute;width:30px;left:10px;" />



      <div v-if="(ordinata(100)>0 && ordinata(100)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(100)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">100</div>
      <div v-if="(ordinata(90)>0 && ordinata(90)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(90)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">90</div>
      <div v-if="(ordinata(80)>0 && ordinata(80)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(80)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">80</div>
      <div v-if="(ordinata(70)>0 && ordinata(70)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(70)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">70</div>
      <div v-if="(ordinata(60)>0 && ordinata(60)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(60)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">60</div>
      <div v-if="(ordinata(50)>0 && ordinata(50)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(50)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">50</div>
      <div v-if="(ordinata(40)>0 && ordinata(40)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(40)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">40</div>
      <div v-if="(ordinata(30)>0 && ordinata(30)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(30)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">30</div>
      <div v-if="(ordinata(20)>0 && ordinata(20)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(20)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">20</div>
      <div v-if="(ordinata(10)>0 && ordinata(10)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(10)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">10</div>
      <div v-if="(ordinata(0)<gHeight+gHeightMore)" :style="'bottom:'+(ordinata(0)+gHeightMore)+'px'" style="position:absolute;width:32px;" class=" white yo-align-right">0</div>




      <div :style="'top:'+(gHeight+gHeightMore-ordinata(network.q3))+'px'" style="border-bottom:1px dashed #008000;position:absolute;right:0;left:40px;" />
      <div :style="'top:'+(gHeight+gHeightMore-ordinata(network.m))+'px'" style="border-bottom:1px dashed #1a476f;position:absolute;right:0;left:40px;" />
      <div :style="'top:'+(gHeight+gHeightMore-ordinata(network.q1))+'px'" style="border-bottom:1px dashed #008000;position:absolute;right:0;left:40px;" />


      <div :style="'height:'+(gHeight+gHeightMore*2)+'px'" style="background:grey;float:left;width:40px;color:white;text-align:center;" />


      <div  style="float:left;width:calc(100% - 40px);padding:40px 0 40px 0;"  >
         <div v-for="(itm, index) in items" :key="'_'+itm.centro" v-on:click="centroSel=itm.centro" :class="(itm.centro==centroSel?'selezionato':'')" class="g-confidenza yo-align-center" style="float:left;position:relative;" :style="'height:'+gHeight+'px;width: '+(100/items.length)+'%'" :id="'centro_'+index">
            <div class="g-confidenza-f2" v-if="itm.totale>15" :style="'top:'+(gHeight-ordinata(itm.f2))+'px'" />
            <div class="g-confidenza-m" :style="'top:'+(gHeight-ordinata(itm.m)-5)+'px'"  />
            <div class="g-confidenza-f1" v-if="itm.totale>15" :style="'top:'+(gHeight-ordinata(itm.f1))+'px'" />
            <div class="g-confidenza-line" v-if="itm.totale>15" :style="'top:'+(gHeight-ordinata(itm.f2))+'px;bottom:'+(ordinata(itm.f1))+'px;'" style="position:absolute;width:1px;left:50%;background:black;" />
         </div>
      </div>

   </div>



   <div :style="'height:'+40+'px'" style="background:grey;margin-bottom:22px;color:white;margin-left:40px;" >
      <div v-for="(itm, index) in items" :key="'_'+itm.centro" class="col sm yo-valign-text-center yo-align-center yo-text-s" style="height:40px;float:left;" :style="'width: '+(100/items.length)+'%'" :id="'centro_'+index">
         {{index+1}}
      </div>
   </div>


   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3 yo-text-bold yo-align-right">ASCISSE</div>
         <div class="col s9">Posizione (rango) del centro</div>
   </div>
   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3 yo-text-bold yo-align-right">ORDINATE</div>
         <div class="col s9">Tasso di mortalità (%)</div>
   </div>
   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3 yo-text-bold yo-align-right">LINEE TRATTEGGIATE</div>
         <div class="col s9">La linea centrale rappresenta il tasso di mortalità mediano dell'intero Network mentre quella superiore ed inferiore rappresentano il primo e il terzo quartile della distribuzione dei tassi di mortalità per centro dell'intero Network.</div>
   </div>
   <div class="row pad" style="clear:both;margin-bottom:12px;" >
         <div class="col s3 yo-text-bold yo-align-right">NOTE</div>
         <div class="col s9">
            Per ogni centro è presentata la stima puntuale dell’indicatore (cerchio pieno) con il relativo intervallo di confidenza al 95% (linea verticale).  
            <br />
            Dal grafico sono stati esclusi i centri che hanno inserito meno di 15 schede e non sono stati considerati i neonati con malformazioni congenite letali (esclusi quindi i neonati con i codici: "101","103","105","401","501","502","505","609" in una delle seguenti variabili: bdcd1, bdcd2, bdcd3, bdcd4, bdcd5).
            <br />
            I tassi (percentuali) di mortalità aggiustati (shrunken) sono stati ottenuti da modello logistico multilevel random intercept (centro) aggiustato per le seguenti variabili: età gestazionale, sga, apgar a 1 minuto, inborn/outborn, gemellarità, tipo di parto.

            <br />
            In colore rosso è evidenziato il vostro centro.</div> 
   </div>


   <div v-if="false" class="row pad" style="clear:both;margin-bottom:12px;" ><div class="col s9 offset-s3">

      <div class="row " style="clear:both;background:grey;color:white" >
         <div class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">NUM</div>
         <!-- <div class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">CENTRO</div> -->
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">CASI</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">TOT</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Q1</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Mortalità (%)</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Q3</div>
      </div>



      <div class="row " style="border-bottom:1px solid lightgrey;"  >
         <div class="col s1 yo-valign-text-center yo-align-center" style="height:24px;">#</div>
         <!-- <div class="col s1 yo-valign-text-center yo-align-center" style="height:24px;" >network</div> -->
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;">{{network.valore}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{network.totale}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{q1}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{network.m}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{q3}}</div>
      </div>



      <div class="row " style="clear:both;background:grey;color:white" >
         <div class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">NUM</div>
         <div v-if="false" class="col s1 yo-valign-text-center yo-align-center" style="height:40px;">CENTRO</div> 
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">CASI</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">TOT</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">I.C. 95% inf</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">Mortalità (%)</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:40px;">I.C. 95% sup.</div>
      </div>


      <div class="row " style="border-bottom:1px solid lightgrey;" v-for="(itm, index) in items" :key="itm.centro" v-on:click="centroSel=itm.centro" >
         <div class="col s1 yo-valign-text-center yo-align-center" style="height:24px;">{{index+1}}</div>
         <div v-if="false" class="col s1 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.centro}}</div> 
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;">{{itm.valore}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.totale}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.f1}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.m}}</div>
         <div class="col s2 yo-valign-text-center yo-align-center" style="height:24px;" >{{itm.f2}}</div>
      </div>

   </div></div>

</div>

</div>
</template>

<script>
import { quantileSeq,std,mean } from 'mathjs'
export default {
components: {
   
},
data() {
   return {
      loading:{}
      ,items: []
      ,network: {q1: 7.3, m: 11.8, q3: 15.3}
      ,centroSel: this.$centro.referente.row.centro
      ,limitebasso:100
      ,limitealto:0



      ,ready: false
      ,needReload: false
      ,item:{}

      ,gHeight:540
      ,gHeightMore:40
      ,ordinataMin: 0
      ,ordinataMax: 100
      

      ,gaweakDown:22
      ,gaweakUp:31


   }
},
created () {
   this.makeanalisi ()
},
methods: {
   async makeanalisi () {
      
      this.loading = this.$loading({lock: true, text: 'Caricamente in corso, non ricaricare la pagina.....', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      let q = await this.$axios.query('fetchAll',`SELECT centro AS centro, m AS m, f1 AS f1, f2 AS f2, 100 AS totale FROM sin_inn.shrunken WHERE variabile='fdisp' ORDER BY ranking`,{})
      this.items = q.result


      this.ordinataMin = this.items[0].f1//(this.items[0].f1 - 10>0) ? this.items[0].f1 - 10 : 0
      this.ordinataMax = 50//parseFloat(this.items[this.items.length - 1].f2) //(parseFloat(this.items[this.items.length - 1].f2) + 10<100) ? parseFloat(this.items[this.items.length - 1].f2) + 10 : 100

      let ultimo = this.items[this.items.length - 1]
      console.log("MIN: "+this.ordinataMin+" - MAX: "+ this.ordinataMax)

      let allValues = []
      for (let itm of this.items){
         allValues.push(itm.m)
         if(this.ordinataMax<parseFloat(itm.f2))
            this.ordinataMax = parseFloat(itm.f2)
         this.limitebasso = (itm.f1<this.limitebasso) ? itm.f1 : this.limitebasso
         this.limitealto = (itm.f2>this.limitealto) ? itm.f2 : this.limitealto
      }      

      this.loading.close()
      this.ready = true
   },

   ordinataP(val){
      let newval = val*this.gHeight/this.ordinataMax 
      console.log(newval*100/this.gHeight)
      return newval*100/this.gHeight
   },

   ordinata(val){
      let traslazione=(this.limitebasso)*this.gHeight/100;
      let top=(this.limitealto*this.gHeight/100)-140;
      console.log(val*this.gHeight/this.ordinataMax)
      return (val*(this.gHeight+traslazione+top)/this.ordinataMax)-traslazione
   }
}, 
computed:{
   rTable:function(){      
      return 'r' + this.$centro.referente.row.centro
   }
}
}
</script>


<style >
.report_basico .vRow{
    background: #BDD1E8;
    background: #fbeafa;
}
.report_basico .vRow:nth-child(odd) {
    color: grey;
    background: #d7e5f7;
}
</style>
